import { useState, useEffect } from 'react';
import { db } from './firebase';
import { collection, onSnapshot, query, orderBy, getDocs } from 'firebase/firestore';

const RealTimeOrders = ({ user }) => {
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    if (user) {
      const q = query(collection(db, 'orders'), orderBy('timestamp', 'desc'));
      const unsubscribe = onSnapshot(q, async (snapshot) => {
        const orderList = [];
        for (const orderDoc of snapshot.docs) {
          const itemsSnapshot = await getDocs(collection(db, 'orders', orderDoc.id, 'items'));
          const items = itemsSnapshot.docs.map(itemDoc => ({
            id: itemDoc.id,
            ...itemDoc.data()
          }));
          orderList.push({
            id: orderDoc.id,
            ...orderDoc.data(),
            items,
            timestamp: orderDoc.data().timestamp?.toDate()
          });
        }
        setOrders(orderList);
      });
      return () => unsubscribe();
    }
  }, [user]);

  return (
    <div>
      <h2>Real-Time Orders</h2>
      <div className="orders-grid">
        {orders.length === 0 ? (
          <p>No orders found.</p>
        ) : (
          orders.map(order => (
            <div key={order.id} className="order-card">
              <p><strong>Order ID:</strong> {order.id}</p>
              <p><strong>Total:</strong> ${order.total?.toFixed(2) || '0.00'}</p>
              <p><strong>Timestamp:</strong> {order.timestamp?.toLocaleString() || 'N/A'}</p>
              <p><strong>Items:</strong></p>
              <ul>
                {Array.isArray(order.items) && order.items.length > 0 ? (
                  order.items.map((item, index) => (
                    <li key={index}>{item.eventID} (x1)</li> // No quantity field, assuming 1
                  ))
                ) : (
                  <li>No items</li>
                )}
              </ul>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default RealTimeOrders;